import React from "react";
import { OurSolIcon } from "../../assets/img";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "./OurSolutions.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OurSolutions = ({ title, description, sliderData }) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const renderSwiperSlide = (ele, idx) => (
		<SwiperSlide key={idx}>
			<Fade direction='down' triggerOnce={true}>
				<div
					onClick={() => navigate(`/services/${ele?.id}`)}
					className='solution-slide h-[230px] group custom-transition bg-section_bg border-[1px] border-gray-200 shadow-lg rounded-md hover:shadow-xl custom-transition text-center py-10 px-6'>
					<div className='m-auto w-max text-center mb-4'>
						<img
							className='w-28 group-hover:scale-105 group-hover:translate-x-1 group-hover:translate-y-1 custom-transition-animations'
							src={ele?.image}
							alt={ele?.title || "Solution Image"}
						/>
					</div>
					<h3 className='cursor-pointer group-hover:text-second_color text-slate-900 webkit-line-clamp-description font-medium text-xl custom-transition'>
						{ele.title}
					</h3>
				</div>
			</Fade>
		</SwiperSlide>
	);

	return (
		<section className='pt-24 md:px-12 px-4 pb-16 ourSolutions'>
			<div>
				<div className='flex justify-center items-center gap-2 mb-4'>
					<img
						loading='lazy'
						className='rotate-animate'
						src={OurSolIcon}
						alt='Solution Icon'
					/>
					<h3 className='text-second_color font-semibold md:text-4xl text-3xl'>
						{title}
					</h3>
				</div>
				<div className='mb-6'>
					<Fade direction='down' triggerOnce={true}>
						<p className='md:text-2xl text-xl md:w-[85%] w-full m-auto font-medium text-slate-950 text-center mb-3'>
							{description}
						</p>
					</Fade>
				</div>
				<div className='mb-10'>
					<Swiper
						slidesPerView={1}
						spaceBetween={20}
						freeMode={true}
						navigation={true}
						loop={true}
						dir={i18n?.language === "ar" ? "rtl" : "ltr"}
						autoplay={{ delay: 2000, disableOnInteraction: false }}
						breakpoints={{ 768: { slidesPerView: 4, spaceBetween: 20 } }}
						modules={[FreeMode, Navigation, Autoplay]}
						className='solution-slides h-[260px] z-10'>
						{sliderData?.map(renderSwiperSlide)}
					</Swiper>
				</div>
				<div className='w-max m-auto z-10 relative'>
					<Fade
						direction={i18n?.language === "ar" ? "right" : "left"}
						triggerOnce={true}>
						<button
							className={`${
								i18n?.language === "en" ? "default-btn-ltr" : "default-btn-rtl"
							} default-btn`}
							onClick={() => navigate("/services")}>
							{t("more about services")}
							{i18n?.language === "ar" ? (
								<HiOutlineArrowSmLeft className='rtl' />
							) : (
								<HiOutlineArrowSmRight className='ltr' />
							)}
							<span></span>
						</button>
					</Fade>
				</div>
			</div>
		</section>
	);
};

export default OurSolutions;
